/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import * as selectorsEquipamentos from '../../../store/equipamento/reducer';
import * as actionsEquipamentos from '../../../store/equipamento/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import { DialogDefaultV2, TabFormV2 } from '../../../components/v2';
import InformacaoBasicaTab from './InformacaoBasicaTab';
import HistoricoTab from './HistoricoTab';

const schema = {
  tipoEquipamento: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  modelo: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const Formulario = ({
  saveEquipamento,
  updateEquipamento,
  selectedEquipamento,
  open,
  id,
  onClose,
  findEquipamentoById,
  authData,
  zIndex,
}) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setValues({
        criadoPor: authData.id,
        criadoPorName: authData.nome,
        dataInclusao: moment().format('DD/MM/YYYY HH:mm:ss'),
        ativo: true,
      });
    } else {
      setValues({});
    }
  }, [authData, open]);

  useEffect(() => {
    if (id) findEquipamentoById(id);
  }, [id, findEquipamentoById]);

  useEffect(() => {
    if (id && selectedEquipamento && id === selectedEquipamento.id) {
      setValues(selectedEquipamento);
    }
  }, [id, selectedEquipamento]);

  const onSave = () => {
    const erros = validate(values, schema);
    setErrors(erros);
    if (!erros) {
      if (values.id) updateEquipamento(values, saveCallback);
      else saveEquipamento(values, saveCallback);
    }
  };

  const saveCallback = (success) => {
    if (success) {
      setValues({});
      onCloseLocal(true);
    }
  };

  const onCloseLocal = (isSave) => {
    setErrors({});
    onClose(isSave);
  };

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Equipamento"
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
      zIndex={zIndex}
    >
      <TabFormV2
        tabPanels={[
          {
            element: (
              <InformacaoBasicaTab
                values={values}
                setValues={setValues}
                errors={errors}
                handleChange={handleChange}
              />
            ),
            label: 'Informações Básicas',
            disabled: false,
          },
          {
            element: (
              <HistoricoTab
                idEquipamento={id}
                historico={values.historico ? values.historico : []}
              />
            ),
            label: 'Histórico',
            disabled: !id,
          },
        ]}
      />
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  saveEquipamento: PropTypes.func.isRequired,
  updateEquipamento: PropTypes.func.isRequired,
  findEquipamentoById: PropTypes.func.isRequired,
  selectedEquipamento: PropTypes.object,
  open: PropTypes.bool,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  authData: PropTypes.object,
  zIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
};

const mapStateToProps = (state) => ({
  selectedEquipamento: selectorsEquipamentos.getSelectedEquipamento(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...actionsEquipamentos,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
